import script from "./surveySession.vue?vue&type=script&setup=true&lang=js"
export * from "./surveySession.vue?vue&type=script&setup=true&lang=js"

import "./surveySession.vue?vue&type=style&index=0&id=2f79225b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f79225b"]])

export default __exports__